import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';

export const Box = styled.a<{
  $isActive?: boolean;
}>`
  position: relative;
  display: grid;
  grid-template-columns: 7fr 3fr;
  column-gap: 10px;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border: 1px solid transparent;
  padding: 10px;
  overflow: hidden;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      border-color: ${({ theme }) => theme.palette.brand.main};
      background-color: ${({ theme }) => theme.palette.tertiary.background};
    `}
`;

export const Texts = styled.div<{ $isBoxLabelPresented?: boolean }>`
  position: relative;
  padding-bottom: ${({ $isBoxLabelPresented }) =>
    $isBoxLabelPresented ? '25px' : '0px'};
`;

export const TitleBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Title = styled(Typography.Header).attrs(() => ({
  $variant: '4',
}))`
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Icons = styled.div`
  display: flex;
`;

export const Description = styled(Typography.Caption).attrs(() => ({
  $variant: '1',
}))`
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Actions = styled.div`
  display: grid;
  gap: 5px;
  align-self: center;
  grid-column: 2/3;
  grid-row: 1/3;
`;

export const Label = styled(Typography.Caption).attrs(() => ({
  $variant: '1',
}))`
  color: ${({ theme }) => theme.palette.brand.main};
  text-align: center;
`;

export const PrevPrice = styled(Typography.Caption).attrs(() => ({
  $variant: '3',
}))<{ $isWhite?: boolean }>`
  color: ${({ theme, $isWhite }) =>
    $isWhite ? theme.palette.primary.background : theme.palette.primary.labels};
  text-align: center;
  position: relative;
  max-width: fit-content;
  justify-self: center;
  white-space: nowrap;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: -2px;
    transform: translate(0, -50%) rotate(-10deg);
    width: calc(100% + 4px);
    height: 2px;
    background-color: ${({ theme, $isWhite }) =>
      $isWhite ? theme.palette.primary.background : theme.palette.system.red};
  }
`;

export const Action = styled(Button)`
  border-radius: 20px;
  white-space: nowrap;
`;

export const BoxLabel = styled(Typography.Caption)<{
  $isVipBg?: boolean;
  $isPremiumBg?: boolean;
}>`
  position: absolute;
  bottom: 0;
  left: 0;
  max-width: fit-content;
  text-transform: uppercase;
  border-radius: 0 7px;
  white-space: nowrap;
  padding: 5px 10px;
  color: ${({ theme }) => theme.palette.primary.background};

  background-color: ${({ theme, $isVipBg, $isPremiumBg }) =>
    $isVipBg
      ? theme.palette.brand.vip1
      : $isPremiumBg
      ? theme.palette.brand.premium1
      : 'transparent'};
`;

export const SmallBox = styled.a<{
  $isActive?: boolean;
}>`
  display: grid;
  grid-column-gap: 5px;
  border-radius: 7px;
  border: ${({ theme, $isActive }) =>
    `1px solid ${
      $isActive ? theme.palette.brand.main : theme.palette.primary.border
    }`};
  background-color: ${({ theme, $isActive }) =>
    $isActive
      ? theme.palette.tertiary.background
      : theme.palette.secondary.background};
  padding: 10px;
`;

export const SmallTitle = styled(Typography.Title).attrs(() => ({
  $variant: '4',
}))`
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const SmallPrice = styled(Typography.Caption).attrs(() => ({
  $variant: '3',
}))`
  color: ${({ theme }) => theme.palette.system.blue};
  grid-row: 2;
`;

export const SmallIcon = styled(IconBox)`
  grid-column: 2;
  grid-row: span 2;
  justify-self: end;
  align-self: center;
`;
